export default {
  endpoint: 'https://dmzls-dev.safe-installation.com',
  index: 'sport-logs'
};
